import { createVanIconComponent } from "./van"

const ClusterOutlined = createVanIconComponent("cluster-o")
export default ClusterOutlined
